import { getCalculatorProductsPrice } from '~/services/calculator.service'
import type {
    ICalculatorRawSetting,
    ICalculatorSelectedValues,
    ICalculatorSetting,
    ICalculatorSettingUpdaters,
    IFieldTitlesBySlug,
} from '~/types/calculator.types'

export const conferenceSystemCalculatorRawSetting: ICalculatorRawSetting = {
    fields: [
        {
            title: 'Количество микрофонов настольных с гибкой ножкой',
            slug: 'microphones_count',
            max_count: 75,
            min_count: 1,
            default_disabled: false,
            default_hidden: false,
        },
        {
            title: 'Микрофон делегата Reinvox CS-1601',
            slug: 'delegat_microphones_count',
            max_count: 75,
            min_count: 1,
            default_disabled: true,
            default_hidden: true,
        },
        {
            title: 'Центральный блок Reinvox CS-1600',
            slug: 'conntectors_count',
            max_count: 75,
            min_count: 1,
            default_disabled: true,
            default_hidden: true,
        },
        {
            title: 'Количество микрофонов настольных с гибкой ножкой',
            slug: 'user_microphones_count',
            max_count: 75,
            default_disabled: true,
            default_hidden: true,
        },
        {
            title: 'Кабель 20 метров для удлинения линии ',
            slug: 'cables_count',
            max_count: 4,
            default_disabled: false,
            default_hidden: false,
        },
    ],
    default_values: {
        delegat_microphones_count: 1,
        user_microphones_count: 20,
        microphones_count: 21,
        cables_count: 1,
        conntectors_count: 1,
    },
    fields_modal: [
        {
            type: 'counter',
            slug: 'delegat_microphones_count',
            prevent_hidden: true,
        },
        {
            type: 'counter',
            slug: 'user_microphones_count',
            prevent_hidden: true,
        },
        {
            type: 'counter',
            slug: 'cables_count',
            prevent_hidden: false,
        },
        {
            type: 'counter',
            slug: 'conntectors_count',
            prevent_hidden: true,
        },
    ],
    fields_order: ['microphones_count', 'cables_count'],
    images: [
        {
            counter_from: 'delegat_microphones_count',
            success_icon: false,
            hide_count: false,
            align: 'row',
            size: 'small',
            images: [
                {
                    image: '/assets/images/products/conference-system/jpg-png/reinvox-concept.png',
                    image_webp:
                        '/assets/images/products/conference-system/webp/reinvox-concept.webp',
                    values: {
                        microphones_count: 'all',
                    },
                },
            ],
        },
        {
            counter_from: 'user_microphones_count',
            success_icon: false,
            hide_count: false,
            align: 'row',
            size: 'small',
            images: [
                {
                    image: '/assets/images/products/conference-system/jpg-png/reinvox-concept.png',
                    image_webp:
                        '/assets/images/products/conference-system/webp/reinvox-concept.webp',
                    values: {
                        microphones_count: 'all',
                    },
                },
            ],
        },
        {
            counter_from: 'conntectors_count',
            success_icon: false,
            hide_count: false,
            align: 'row',
            size: 'small',
            images: [
                {
                    image: '/assets/images/products/connector/jpg-png/connector.png',
                    image_webp:
                        '/assets/images/products/connector/webp/connector.webp',
                    values: {
                        microphones_count: 'all',
                    },
                },
            ],
        },
        {
            counter_from: 'cables_count',
            success_icon: false,
            hide_count: false,
            align: 'row',
            size: 'small',
            images: [
                {
                    image: '/assets/images/products/connector/jpg-png/cable.png',
                    image_webp:
                        '/assets/images/products/connector/webp/cable.webp',
                    values: {
                        cables_count: 'all',
                    },
                },
            ],
        },
    ],
    price_modificators: {
        headphones: {
            de300: 1000,
        },
    },
    prices: {},
}

export const conferenceSystemFieldTitles: IFieldTitlesBySlug = {}

export const conferenceSystemUpdaters: ICalculatorSettingUpdaters = {
    microphones_count: updateConferenceUserMicrophonesCount,
}

function updateConferenceUserMicrophonesCount(
    selectedValues: ICalculatorSelectedValues
): [string, string | number, boolean, boolean][] {
    return [
        [
            'user_microphones_count',
            Number(selectedValues.microphones_count) - 1,
            true,
            true,
        ],
    ]
}

export function conferenceSystemGetPrice(
    calculator: ICalculatorSetting,
    selectedValues: ICalculatorSelectedValues
): string {
    const productPrices: { [key: string]: number } = getCalculatorProductsPrice(
        calculator,
        selectedValues
    )

    const microphonesPrice: number =
        (productPrices['cs1602'] || 0) *
        Number(selectedValues.user_microphones_count)

    const cablesPrice: number =
        (productPrices['utp20'] || 0) * Number(selectedValues.cables_count)

    const price: number =
        microphonesPrice +
        (productPrices['cs1601'] || 0) +
        (productPrices['cs1600'] || 0) +
        cablesPrice

    return formatPrice(price)
}
